import { v4 as uuidv4 } from 'uuid';
class Logger {
    constructor(config) {
        Object.defineProperty(this, "correlationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "logLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDevelopment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.logLevel = config?.logLevel || 'info';
        this.isDevelopment = config?.isDevelopment ?? true;
    }
    generateCorrelationId() {
        this.correlationId = uuidv4();
        return this.correlationId;
    }
    getCorrelationId() {
        return this.correlationId;
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
    clearCorrelationId() {
        this.correlationId = null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getUserId() {
        return this.userId;
    }
    setLogLevel(level) {
        this.logLevel = level;
    }
    setDevelopment(isDevelopment) {
        this.isDevelopment = isDevelopment;
    }
    shouldLog(level) {
        const levels = ['debug', 'info', 'warn', 'error'];
        const currentLevelIndex = levels.indexOf(this.logLevel);
        const messageLevelIndex = levels.indexOf(level);
        return messageLevelIndex >= currentLevelIndex;
    }
    createLogEntry(level, message, metadata, error) {
        const entry = {
            timestamp: new Date().toISOString(),
            level,
            correlation_id: this.correlationId || 'no-correlation-id',
            message,
        };
        if (this.userId) {
            entry.user_id = this.userId;
        }
        if (metadata) {
            entry.metadata = metadata;
        }
        if (error) {
            entry.error = {
                name: error.name,
                message: error.message,
                stack: error.stack,
            };
        }
        return entry;
    }
    output(entry) {
        const consoleMethod = entry.level === 'error' ? console.error : entry.level === 'warn' ? console.warn : console.log;
        if (this.isDevelopment) {
            consoleMethod(`[${entry.level.toUpperCase()}] [${entry.correlation_id.slice(0, 8)}] ${entry.message}`, entry.metadata || '', entry.error || '');
        }
        else {
            consoleMethod(JSON.stringify(entry));
        }
    }
    debug(message, metadata) {
        if (!this.shouldLog('debug'))
            return;
        const entry = this.createLogEntry('debug', message, metadata);
        this.output(entry);
    }
    info(message, metadata) {
        if (!this.shouldLog('info'))
            return;
        const entry = this.createLogEntry('info', message, metadata);
        this.output(entry);
    }
    warn(message, metadata) {
        if (!this.shouldLog('warn'))
            return;
        const entry = this.createLogEntry('warn', message, metadata);
        this.output(entry);
    }
    error(message, error, metadata) {
        if (!this.shouldLog('error'))
            return;
        const entry = this.createLogEntry('error', message, metadata, error);
        this.output(entry);
    }
    child(_context) {
        const childLogger = new Logger({
            logLevel: this.logLevel,
            isDevelopment: this.isDevelopment,
        });
        childLogger.correlationId = this.correlationId;
        childLogger.userId = this.userId;
        return childLogger;
    }
}
export function createLogger(config) {
    return new Logger(config);
}
export const logger = new Logger();
export const CORRELATION_ID_HEADER = 'X-Correlation-ID';
